import { render } from "./QueueView.vue?vue&type=template&id=37aa6470&scoped=true"
import script from "./QueueView.vue?vue&type=script&lang=js"
export * from "./QueueView.vue?vue&type=script&lang=js"

import "./QueueView.vue?vue&type=style&index=0&id=37aa6470&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37aa6470"]])

export default __exports__